

    /**
     * Returns the first argument provided to it.
     */
    function identity(val){
        return val;
    }

    module.exports = identity;





//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/function/identity.js
// module id = 547
// module chunks = 1